import React from 'react';
import { useTranslation } from 'react-i18next';

import { GuardrailBehavior } from '../../../../../../gamma-api';
import IbSelect from '../../../../../components/common/IbSelect';
import IbTypography from '../../../../../components/common/IbTypography';
import { ITEM_CLASS_NAME } from '../../../../../components/common/TypedStepModal/const';

export interface ICheckBehaviorFieldProps {
  value?: GuardrailBehavior;
  onChange: (value: GuardrailBehavior) => void;
}

const CheckBehaviorField: React.FC<ICheckBehaviorFieldProps> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className={ITEM_CLASS_NAME}>
      <IbTypography.Paragraph strong type="secondary">
        {t('Agent: Guardrails: Step: Behavior: Title')}
      </IbTypography.Paragraph>
      <IbTypography.Paragraph type="secondary">
        {t('Agent: Guardrails: Step: Behavior: Description')}
      </IbTypography.Paragraph>
      <IbSelect
        options={[
          {
            value: GuardrailBehavior.Allow,
            label: t('Agent: Guardrails: Step: Behavior: Allow'),
          },
          {
            value: GuardrailBehavior.Block,
            label: t('Agent: Guardrails: Step: Behavior: Block'),
          },
        ]}
        value={value}
        onChange={(selectedValue) => onChange(selectedValue as GuardrailBehavior)}
      />
    </div>
  );
};

export default CheckBehaviorField;
